<script setup lang="ts">
const { data: page } = await useAsyncData(useRoute().path, () => queryCollection('content').path(useRoute().path).first())

const pipedriveScript = useScript({src: 'https://webforms.pipedrive.com/f/loader'})
onBeforeUnmount(() => {
  pipedriveScript.remove()
});

useSeoMeta({
  title: page.value.seo.title,
  description: page.value.seo.description,
})
</script>

<template>
  <UPageSection
      :title="page.meta.hero.title"
      :features="page.meta.hero.features"
      orientation="horizontal"
  >
    <template #headline>
      <UButton to="/collectivite" variant="ghost" icon="i-ph-arrow-left" color="neutral">Retour</UButton>
      <div class="space-x-10 py-5">
        <UAvatar v-for="(avatar, index) in page.meta.hero.avatars"
                 :key="index" :src="avatar.src" size="4xl" class="ring-8 ring-white shadow-2xl" :alt="avatar.alt"></UAvatar>
      </div>
    </template>
    <div class="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/048d0c3f6502f862a1234f87207ed9691741059"></div>
  </UPageSection>
</template>
